import { NextRouter } from 'next/router';
import { MouseEvent } from 'react';
import { possiblyFalseyLinkHandler } from 'shared/helpers';

type Args = {
    evt: MouseEvent<HTMLElement>;
    router: NextRouter;
    requiresAuth?: boolean;
    loggedIn?: boolean;
};

type AlertLinkClickHandler = (args: Args) => void;

export const alertLinkClickHandler: AlertLinkClickHandler = ({
    evt,
    router,
    requiresAuth = false,
    loggedIn = false
}) => {
    const destinationUrl = evt.currentTarget.dataset.url as string;
    const redirectUrl = encodeURIComponent(destinationUrl || router.asPath);

    if (requiresAuth && !loggedIn) {
        return router.push(
            `${
                process.env.REGISTER_PATH || /register/
            }?page_after_login=${redirectUrl}&return_url=${redirectUrl}`
        );
    }

    possiblyFalseyLinkHandler(destinationUrl, router);
};
